import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import { ExecutionStep } from "../types";
import JsonView from "../JsonView";

interface BundlesModalProps {
    moduleLabel: string;
    steps: ExecutionStep[] | null;
    onClose: () => void;
}

/** What one module received and returned in a run, operation by operation. */
const BundlesModal = ({ moduleLabel, steps, onClose }: BundlesModalProps) => {
    const { t } = useTranslation(['workflow']);
    const [index, setIndex] = useState(0);
    const list = steps || [];
    const step = list[Math.min(index, list.length - 1)];

    return (
        <Modal show={steps !== null} onHide={() => { setIndex(0); onClose(); }} size="lg" scrollable>
            <Modal.Header closeButton><Modal.Title>{moduleLabel}</Modal.Title></Modal.Header>
            <Modal.Body>
                {list.length > 1 &&
                    <div className="d-flex flex-wrap gap-1 mb-3">
                        {list.map((s, i) => (
                            <button key={s.uuid} type="button" className={"btn btn-sm " + (i === index ? 'btn-primary' : s.status === 'error' ? 'btn-soft-danger' : 'btn-light')} onClick={() => setIndex(i)}>
                                {t('workflow:operation')} {i + 1}
                            </button>
                        ))}
                    </div>
                }
                {step &&
                    <>
                        <div className="small text-muted mb-2">{t('workflow:status')}: {t('workflow:stepStatus_' + step.status, { defaultValue: step.status })}{step.attempt > 1 ? ` · ${t('workflow:attempt')} ${step.attempt}` : ''}</div>
                        {step.error && <div className="alert alert-danger py-2"><strong>{step.error.type}</strong>: {step.error.message}</div>}
                        <h6 className="small text-uppercase text-muted">{t('workflow:input')}</h6>
                        <JsonView value={step.input} />
                        <h6 className="small text-uppercase text-muted mt-3">{t('workflow:output')} ({(step.output || []).length})</h6>
                        <JsonView value={step.output} />
                    </>
                }
            </Modal.Body>
        </Modal>
    );
};

export default BundlesModal;
